var _path, _path2, _g, _path3, _g2, _path4, _path5, _g3, _g4, _path6, _g5, _g6, _g7, _g8, _g9, _g10, _g11, _g12, _path7, _path8, _path9, _path10, _path11, _path12, _g13, _path13, _g14, _path14, _g15, _path15, _path16, _path17, _g16, _path18, _path19, _path20, _g17, _path21, _g18, _path22, _g19, _path23, _g20, _g21, _path24, _path25, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgTeslaSocket(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 110,
    height: 110,
    viewBox: "0 0 110 110",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_668_20221)"
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M98.403 48.512C97.0361 27.8553 82.8594 22 61.3677 22C53.7955 22 44.0917 22 34.7466 22.917C23.7098 24.0039 12.7068 29.0984 11.103 46.481C11.103 46.481 8.29473 69.9295 22.7286 87.1898C22.803 87.2781 22.8774 87.3664 22.9519 87.4548C23.2902 87.8555 23.6353 88.2495 23.9872 88.6367C24.1767 88.8473 24.3797 89.0578 24.5759 89.2616C24.8466 89.5469 25.1105 89.8322 25.3947 90.1107C25.9022 90.6202 26.4301 91.1228 26.9782 91.6187C33.4135 97.4265 46.4398 101.869 56.015 101.251C69.0143 100.415 75.8962 96.5434 81.8647 91.4489C82.3857 91.0006 82.9 90.5183 83.4075 90.0156C92.7053 80.8862 99.3707 63.2455 98.3962 48.5052L98.403 48.512Z",
    fill: "#E6E8E8"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M92.3331 48.6685C92.3331 70.0588 76.7421 88.8135 55.4331 88.8135C34.1241 88.8135 17.6669 71.4513 17.6669 50.061C17.6669 28.6707 24.2308 21.1172 55.4331 21.1172C86.6353 21.1172 92.3331 27.2782 92.3331 48.6685Z",
    fill: "#1E272D"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.23
  }, /*#__PURE__*/React.createElement("path", {
    d: "M92.3331 48.3288C93.7406 45.7204 94.5459 42.7316 94.5459 39.5526C94.5459 29.3703 86.324 21.1239 76.1872 21.1239C74.2857 21.1239 72.4519 21.416 70.7263 21.9526C66.4496 21.382 61.4083 21.1239 55.4466 21.1239C48.9639 21.1239 43.5571 21.4567 39.0436 22.1632C37.1489 21.5043 35.1256 21.1239 33.0075 21.1239C22.8639 21.1239 14.6489 29.3771 14.6489 39.5526C14.6489 43.3022 15.7722 46.7868 17.6872 49.6941C17.6872 49.8164 17.6872 49.9387 17.6872 50.0677C17.6872 58.9798 20.5496 67.1786 25.4218 73.7268C25.3677 74.0325 25.3338 74.3382 25.3338 74.6438C25.3338 82.9513 38.2383 89.6897 54.1609 89.6897C70.0834 89.6897 82.0406 83.4336 82.9338 75.5473C88.8616 68.313 92.3534 58.7896 92.3534 48.6752C92.3534 48.5597 92.3534 48.4443 92.3534 48.3288H92.3331ZM82.1353 71.7162C79.0428 65.9695 67.688 59.6047 54.1474 59.6047C46.2977 59.6047 31.5797 64.2645 26.8428 70.6089C23.5541 65.6502 21.4631 59.7881 20.9624 53.4437C24.1902 56.2627 28.3925 57.9813 33.0007 57.9813C43.1444 57.9813 51.3594 49.7281 51.3594 39.5526C51.3594 33.3372 48.2872 27.8555 43.5977 24.5203C47.0218 24.1603 50.9398 23.9904 55.406 23.9904C59.2767 23.9904 62.721 24.1127 65.8 24.364C60.9887 27.6857 57.8286 33.2489 57.8286 39.5526C57.8286 49.7349 66.0504 57.9813 76.1872 57.9813C81.188 57.9813 85.7083 55.9706 89.024 52.7169C88.4083 59.727 85.9654 66.2956 82.1421 71.7094L82.1353 71.7162Z",
    fill: "#0D1214"
  }))), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M98.403 42.5346C97.0361 21.8779 82.8594 16.0226 61.3677 16.0226C53.7955 16.0226 44.0917 16.0226 34.7466 16.9396C23.7098 18.0264 12.7068 23.121 11.103 40.5036C11.103 40.5036 8.29473 63.9521 22.7286 81.2124C22.803 81.3007 22.8774 81.389 22.9519 81.4773C23.2902 81.8781 23.6353 82.2721 23.9872 82.6593C24.1767 82.8698 24.3797 83.0804 24.5759 83.2842C24.8466 83.5695 25.1105 83.8548 25.3947 84.1333C25.9022 84.6427 26.4301 85.1454 26.9782 85.6413C33.4135 91.4491 46.4398 95.8915 56.015 95.2734C69.0143 94.4379 75.8962 90.566 81.8647 85.4715C82.3857 85.0231 82.9 84.5409 83.4075 84.0382C92.7053 74.9088 99.3707 57.268 98.3962 42.5278L98.403 42.5346Z",
    fill: "#3F5D6A"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.25
  }, /*#__PURE__*/React.createElement("path", {
    d: "M39.0337 46.8371C43.4918 42.362 43.4918 35.1063 39.0337 30.6312C34.5755 26.156 27.3474 26.156 22.8893 30.6312C18.4312 35.1063 18.4312 42.362 22.8893 46.8371C27.3474 51.3123 34.5755 51.3123 39.0337 46.8371Z",
    fill: "#445B68"
  }))), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M30.9639 47.0993C35.5645 47.0993 39.294 43.3556 39.294 38.7375C39.294 34.1193 35.5645 30.3756 30.9639 30.3756C26.3633 30.3756 22.6338 34.1193 22.6338 38.7375C22.6338 43.3556 26.3633 47.0993 30.9639 47.0993Z",
    fill: "#445B68"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M34.5233 41.6311C32.9331 43.601 30.0504 43.9067 28.0812 42.3104C26.1188 40.7141 25.8143 37.8204 27.4045 35.8437C28.9947 33.8738 31.8774 33.5682 33.8466 35.1645C35.809 36.7608 36.1135 39.6545 34.5233 41.6311Z",
    fill: "#B3B3B3"
  })), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.2
  }, /*#__PURE__*/React.createElement("path", {
    d: "M79.9653 49.9169C86.1015 48.4631 89.9018 42.2912 88.4535 36.1317C87.0053 29.9721 80.8569 26.1573 74.7207 27.6111C68.5845 29.0649 64.7842 35.2367 66.2325 41.3963C67.6808 47.5559 73.8292 51.3707 79.9653 49.9169Z",
    fill: "white"
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.23
  }, /*#__PURE__*/React.createElement("path", {
    d: "M77.3444 49.1711C83.0848 49.1711 87.7383 44.4998 87.7383 38.7375C87.7383 32.9751 83.0848 28.3038 77.3444 28.3038C71.6039 28.3038 66.9504 32.9751 66.9504 38.7375C66.9504 44.4998 71.6039 49.1711 77.3444 49.1711Z",
    fill: "#0D1214"
  }))), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M74.3737 38.7579C74.3737 40.4085 75.7068 41.7399 77.3444 41.7399C78.9819 41.7399 80.315 40.4017 80.315 38.7579C80.315 37.114 78.9819 35.7759 77.3444 35.7759C75.7068 35.7759 74.3737 37.114 74.3737 38.7579Z",
    fill: "#1E272D"
  })), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.2
  }, /*#__PURE__*/React.createElement("path", {
    d: "M39.294 75.1805C39.294 77.3406 37.5549 79.0863 35.403 79.0863C33.2511 79.0863 31.512 77.3406 31.512 75.1805C31.512 73.0204 33.2511 71.2747 35.403 71.2747C37.5549 71.2747 39.294 73.0204 39.294 75.1805Z",
    fill: "white"
  }))), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.23
  }, /*#__PURE__*/React.createElement("path", {
    d: "M37.3789 75.1805C37.3789 76.2741 36.4925 77.164 35.403 77.164C34.3135 77.164 33.4271 76.2741 33.4271 75.1805C33.4271 74.0869 34.3135 73.197 35.403 73.197C36.4925 73.197 37.3789 74.0869 37.3789 75.1805Z",
    fill: "#0D1214"
  }))), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.2
  }, /*#__PURE__*/React.createElement("path", {
    d: "M76.1804 75.1805C76.1804 77.3406 74.4413 79.0863 72.2895 79.0863C70.1376 79.0863 68.3985 77.3406 68.3985 75.1805C68.3985 73.0204 70.1376 71.2747 72.2895 71.2747C74.4413 71.2747 76.1804 73.0204 76.1804 75.1805Z",
    fill: "white"
  }))), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.23
  }, /*#__PURE__*/React.createElement("path", {
    d: "M74.2654 75.1805C74.2654 76.2741 73.3789 77.164 72.2895 77.164C71.2 77.164 70.3135 76.2741 70.3135 75.1805C70.3135 74.0869 71.2 73.197 72.2895 73.197C73.3789 73.197 74.2654 74.0869 74.2654 75.1805Z",
    fill: "#0D1214"
  }))), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.2
  }, /*#__PURE__*/React.createElement("path", {
    d: "M59.3173 73.7608C59.3173 76.8583 56.8135 79.3716 53.7278 79.3716C50.6421 79.3716 48.1383 76.8583 48.1383 73.7608C48.1383 70.6633 50.6421 68.15 53.7278 68.15C56.8135 68.15 59.3173 70.6633 59.3173 73.7608Z",
    fill: "white"
  }))), _g10 || (_g10 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.23
  }, /*#__PURE__*/React.createElement("path", {
    d: "M57.6797 73.7608C57.6797 75.9548 55.9068 77.7277 53.7278 77.7277C51.5489 77.7277 49.7759 75.9548 49.7759 73.7608C49.7759 71.5667 51.5489 69.7938 53.7278 69.7938C55.9068 69.7938 57.6797 71.5735 57.6797 73.7608Z",
    fill: "#0D1214"
  }))), _g11 || (_g11 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.09
  }, /*#__PURE__*/React.createElement("path", {
    d: "M60.4 85.4579H48.5037C47.685 85.4579 47.015 84.7922 47.015 83.9635C47.015 83.1416 47.6782 82.4691 48.5037 82.4691H60.4C61.2188 82.4691 61.8887 83.1348 61.8887 83.9635C61.8887 84.7854 61.2256 85.4579 60.4 85.4579Z",
    fill: "white"
  }))), _g12 || (_g12 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.23
  }, /*#__PURE__*/React.createElement("path", {
    d: "M60.3662 85.1997H48.5038C47.8271 85.1997 47.2789 84.6495 47.2789 83.9702C47.2789 83.2909 47.8271 82.7407 48.5038 82.7407H60.3662C61.0429 82.7407 61.591 83.2909 61.591 83.9702C61.591 84.6495 61.0429 85.1997 60.3662 85.1997Z",
    fill: "#0D1214"
  }))), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M54.9865 73.6997C55.8049 73.6997 56.4684 73.0337 56.4684 72.2121C56.4684 71.3905 55.8049 70.7245 54.9865 70.7245C54.168 70.7245 53.5045 71.3905 53.5045 72.2121C53.5045 73.0337 54.168 73.6997 54.9865 73.6997Z",
    fill: "#1E272D"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M73.0338 75.1804C73.0338 75.5948 72.7022 75.9276 72.2895 75.9276C71.8767 75.9276 71.5451 75.5948 71.5451 75.1804C71.5451 74.7661 71.8767 74.4332 72.2895 74.4332C72.7022 74.4332 73.0338 74.7661 73.0338 75.1804Z",
    fill: "#1E272D"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M36.1474 75.1804C36.1474 75.5948 35.8158 75.9276 35.403 75.9276C34.9902 75.9276 34.6586 75.5948 34.6586 75.1804C34.6586 74.7661 34.9902 74.4332 35.403 74.4332C35.8158 74.4332 36.1474 74.7661 36.1474 75.1804Z",
    fill: "#1E272D"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M54.4519 75.1805C54.4519 76.0024 53.7887 76.6681 52.9699 76.6681C52.1511 76.6681 51.488 76.0024 51.488 75.1805C51.488 74.3586 52.1511 73.6929 52.9699 73.6929C53.7887 73.6929 54.4519 74.3586 54.4519 75.1805Z",
    fill: "#1E272D"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M96.4203 43.1324C95.121 23.4063 81.5804 17.8159 61.0632 17.8159C53.8293 17.8159 44.5654 17.8159 35.6466 18.6922C25.1105 19.7315 14.6083 24.5951 13.0722 41.1897C13.0722 41.1897 10.3857 63.5785 24.1699 80.0577C24.2376 80.1392 24.312 80.2275 24.3797 80.309C24.7045 80.6894 25.0293 81.0698 25.3677 81.4366C25.5504 81.6404 25.7398 81.8374 25.9293 82.0344C26.1865 82.3061 26.4436 82.5778 26.7075 82.8495C27.1947 83.3386 27.6955 83.8141 28.2165 84.2896C34.3609 89.8324 46.7917 94.0779 55.9406 93.4869C68.3511 92.6854 74.9218 88.9901 80.6263 84.1265C81.1271 83.6986 81.6143 83.2367 82.1015 82.7544C90.9797 74.0326 97.3406 57.1934 96.4135 43.1188L96.4203 43.1324Z",
    fill: "#4F6B77"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M87.0346 49.6601C87.0346 68.0413 73.6429 84.1536 55.3316 84.1536C37.0203 84.1536 22.8842 69.2368 22.8842 50.8624C22.8842 32.4881 28.5211 25.9943 55.3316 25.9943C82.1421 25.9943 87.0346 31.2858 87.0346 49.6669V49.6601Z",
    fill: "#1E272D"
  })), _g13 || (_g13 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.23
  }, /*#__PURE__*/React.createElement("path", {
    d: "M87.0278 49.3613C88.2391 47.1197 88.9293 44.5521 88.9293 41.8214C88.9293 33.0792 81.8647 25.9875 73.1556 25.9875C71.518 25.9875 69.9481 26.2389 68.4594 26.7008C64.785 26.2049 60.4541 25.9875 55.3316 25.9875C49.7624 25.9875 45.1203 26.2728 41.2361 26.8842C39.612 26.3136 37.8662 25.9875 36.0526 25.9875C27.3436 25.9875 20.2789 33.0792 20.2789 41.8214C20.2789 45.0412 21.2398 48.0368 22.891 50.5365C22.891 50.6452 22.891 50.747 22.891 50.8557C22.891 58.5111 25.3474 65.562 29.5361 71.1864C29.4887 71.4445 29.4617 71.7094 29.4617 71.9743C29.4617 79.1135 40.5526 84.9009 54.2286 84.9009C67.9045 84.9009 78.1835 79.5278 78.9481 72.7487C84.0436 66.5334 87.0414 58.3549 87.0414 49.6602C87.0414 49.5583 87.0414 49.4632 87.0414 49.3613H87.0278ZM78.2647 69.4542C75.6053 64.5159 65.8541 59.0478 54.215 59.0478C47.4684 59.0478 34.8278 63.0487 30.7541 68.5032C27.9256 64.2442 26.1323 59.204 25.6992 53.7562C28.4669 56.1744 32.0805 57.6553 36.0391 57.6553C44.7549 57.6553 51.8128 50.5636 51.8128 41.8214C51.8128 36.4823 49.1737 31.775 45.1406 28.9016C48.0842 28.5892 51.4474 28.4465 55.2842 28.4465C58.6135 28.4465 61.5707 28.5484 64.2098 28.7658C60.0752 31.6187 57.3617 36.4008 57.3617 41.8146C57.3617 50.5636 64.4263 57.6485 73.1353 57.6485C77.4323 57.6485 81.3165 55.9231 84.1586 53.1245C83.6308 59.1497 81.5263 64.7876 78.2444 69.4474L78.2647 69.4542Z",
    fill: "#0D1214"
  }))), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M92.2451 44.389C91.0744 26.6396 78.894 21.6062 60.4271 21.6062C53.9173 21.6062 45.5804 21.6062 37.5549 22.3942C28.0744 23.3248 18.621 27.7061 17.2406 42.6433C17.2406 42.6433 14.8248 62.7905 27.2286 77.619C27.2895 77.6938 27.3571 77.7685 27.418 77.8432C27.709 78.1828 28 78.5225 28.3113 78.8621C28.4737 79.0455 28.6496 79.2221 28.8188 79.3987C29.0489 79.6433 29.2789 79.8878 29.5226 80.1324C29.9624 80.5739 30.409 81.0018 30.8827 81.4298C36.4113 86.4224 47.6038 90.2399 55.8323 89.7101C66.9977 88.9901 72.912 85.6616 78.0414 81.2871C78.4947 80.8999 78.9346 80.4856 79.3677 80.0508C87.3594 72.2052 93.0842 57.0507 92.2451 44.389Z",
    fill: "#1E272D"
  })), _g14 || (_g14 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.35
  }, /*#__PURE__*/React.createElement("path", {
    d: "M92.2451 44.389C91.0744 26.6396 78.894 21.6062 60.4271 21.6062C53.9173 21.6062 45.5805 21.6062 37.5549 22.3942C28.0744 23.3248 18.6211 27.7061 17.2406 42.6433C17.2406 42.6433 16.0361 52.7237 19.7173 63.8706C20.7865 59.9783 22.7218 56.3103 25.3947 53.2943C31.9654 45.897 42.3662 42.4463 52.1985 43.4312C62.4301 44.4637 72.1068 50.1425 78.021 58.5858C79.591 60.8342 80.9173 63.2728 82.7579 65.297C83.9962 66.6624 85.5459 67.8307 87.2511 68.4557C90.7496 61.0244 92.7526 52.221 92.2383 44.3754L92.2451 44.389Z",
    fill: "#1D2528"
  }))), /*#__PURE__*/React.createElement("g", {
    opacity: 0.25
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_668_20221",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 24,
    y: 31,
    width: 21,
    height: 20
  }, _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M34.3068 50.978C39.7258 50.978 44.1188 46.5682 44.1188 41.1285C44.1188 35.6888 39.7258 31.2791 34.3068 31.2791C28.8877 31.2791 24.4947 35.6888 24.4947 41.1285C24.4947 46.5682 28.8877 50.978 34.3068 50.978Z",
    fill: "white"
  }))), _g15 || (_g15 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_668_20221)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M42.4609 50.9712L44.112 40.0281V50.9712H42.4609Z",
    fill: "#294451"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M38.2654 50.9712L41.2361 31.2791H44.112V40.0281L42.4609 50.9712H38.2654Z",
    fill: "#294350"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34.0632 50.9712L37.0338 31.2791H41.2361L38.2654 50.9712H34.0632Z",
    fill: "#29424F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.8609 50.9712L32.8316 31.2791H37.0338L34.0632 50.9712H29.8609Z",
    fill: "#28414E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.6586 50.9712L28.6361 31.2791H32.8316L29.8609 50.9712H25.6586Z",
    fill: "#28404D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.6361 31.2791L25.6586 50.9712H24.4947V31.2791H28.6361Z",
    fill: "#273F4C"
  })))), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M41.3771 42.2753C42.0106 38.3575 39.3602 34.6659 35.4573 34.0299C31.5544 33.394 27.8768 36.0545 27.2433 39.9723C26.6097 43.8901 29.2601 47.5817 33.1631 48.2177C37.066 48.8536 40.7435 46.1931 41.3771 42.2753Z",
    fill: "url(#paint0_linear_668_20221)"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M37.3654 43.6079C35.9985 45.306 33.5218 45.5642 31.8301 44.192C30.1383 42.8199 29.8812 40.3338 31.2481 38.6356C32.615 36.9374 35.0917 36.6793 36.7835 38.0514C38.4752 39.4235 38.7323 41.9097 37.3654 43.6079Z",
    fill: "url(#paint1_linear_668_20221)"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.25
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask1_668_20221",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 63,
    y: 31,
    width: 20,
    height: 20
  }, _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M73.1556 50.978C78.5747 50.978 82.9677 46.5682 82.9677 41.1285C82.9677 35.6888 78.5747 31.2791 73.1556 31.2791C67.7366 31.2791 63.3436 35.6888 63.3436 41.1285C63.3436 46.5682 67.7366 50.978 73.1556 50.978Z",
    fill: "white"
  }))), _g16 || (_g16 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask1_668_20221)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M80.2677 50.9711L82.9609 33.0927V50.9711H80.2677Z",
    fill: "#2D4D5A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M76.0654 50.9712L79.0361 31.2791H82.9609V33.0927L80.2677 50.9712H76.0654Z",
    fill: "#2D4C59"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M71.8632 50.9712L74.8406 31.2791H79.0361L76.0654 50.9712H71.8632Z",
    fill: "#2C4B58"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M67.6677 50.9712L70.6383 31.2791H74.8406L71.8632 50.9712H67.6677Z",
    fill: "#2C4A57"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M63.4654 50.9712L66.4361 31.2791H70.6383L67.6677 50.9712H63.4654Z",
    fill: "#2C4956"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M66.4361 31.2791L63.4654 50.9712H63.3436V31.2791H66.4361Z",
    fill: "#2B4855"
  })))), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M57.0707 35.7486C57.0707 33.2829 58.194 30.2194 57.3481 29.2208C56.9624 28.6842 55.3586 28.6978 54.4383 28.6978C53.518 28.6978 50.9804 28.854 50.9466 29.6624C50.4865 30.5454 51.5489 33.4527 51.5489 35.9185C51.5489 48.4103 43.6045 58.742 31.6677 60.5625C29.9827 60.8206 28.8865 62.5392 29.4346 64.1626C29.5564 64.5294 29.6917 64.8894 29.8338 65.2495C30.4361 66.7914 32.3038 67.4707 33.7383 66.642C40.1195 62.9739 47.5023 60.8682 55.3789 60.8682C62.6669 60.8682 69.5083 62.6954 75.5444 65.8676C77.0195 66.642 78.8534 65.8608 79.4015 64.2849C79.4083 64.2645 79.415 64.2441 79.4218 64.217C79.9902 62.5731 78.9007 60.9021 77.2023 60.5557C63.0188 57.6892 57.0707 48.2269 57.0707 35.7418V35.7486Z",
    fill: "#4F6B77"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M80.315 41.1285C80.315 45.0954 77.1075 48.3152 73.1556 48.3152C69.2038 48.3152 65.9962 45.0954 65.9962 41.1285C65.9962 37.1615 69.2038 33.9418 73.1556 33.9418C77.1075 33.9418 80.315 37.1615 80.315 41.1285Z",
    fill: "url(#paint2_linear_668_20221)"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M76.2143 43.6079C74.8474 45.306 72.3707 45.5642 70.6789 44.192C68.9872 42.8199 68.7301 40.3338 70.097 38.6356C71.4639 36.9374 73.9406 36.6793 75.6323 38.0514C77.3241 39.4235 77.5812 41.9097 76.2143 43.6079Z",
    fill: "url(#paint3_linear_668_20221)"
  })), _g17 || (_g17 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.25
  }, /*#__PURE__*/React.createElement("path", {
    d: "M41.9331 72.4362C41.9331 74.5487 40.2278 76.2673 38.1233 76.2673C36.0188 76.2673 34.3068 74.5555 34.3068 72.4362C34.3068 70.3169 36.012 68.6051 38.1233 68.6051C40.2346 68.6051 41.9331 70.3169 41.9331 72.4362Z",
    fill: "#445B68"
  }))), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M40.0587 72.4363C40.0587 73.5095 39.1925 74.379 38.1233 74.379C37.0541 74.379 36.188 73.5095 36.188 72.4363C36.188 71.363 37.0541 70.4935 38.1233 70.4935C39.1925 70.4935 40.0587 71.363 40.0587 72.4363Z",
    fill: "url(#paint4_linear_668_20221)"
  })), _g18 || (_g18 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.25
  }, /*#__PURE__*/React.createElement("path", {
    d: "M73.6293 72.4362C73.6293 74.5555 71.9173 76.2673 69.8128 76.2673C67.7083 76.2673 65.9962 74.5487 65.9962 72.4362C65.9962 70.3237 67.7083 68.6051 69.8128 68.6051C71.9173 68.6051 73.6293 70.3237 73.6293 72.4362Z",
    fill: "#445B68"
  }))), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M71.7481 72.4362C71.7481 73.5095 70.882 74.3857 69.806 74.3857C68.7301 74.3857 67.8639 73.5163 67.8639 72.4362C67.8639 71.3562 68.7301 70.4867 69.806 70.4867C70.882 70.4867 71.7481 71.3562 71.7481 72.4362Z",
    fill: "url(#paint5_linear_668_20221)"
  })), _g19 || (_g19 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.25
  }, /*#__PURE__*/React.createElement("path", {
    d: "M59.2767 71.2136C59.2767 74.2159 56.8541 76.6545 53.8564 76.6545C50.8586 76.6545 48.4361 74.2227 48.4361 71.2136C48.4361 68.2044 50.8586 65.7726 53.8564 65.7726C56.8541 65.7726 59.2767 68.2044 59.2767 71.2136Z",
    fill: "#445B68"
  }))), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M57.6932 71.2135C57.6932 73.3396 55.9812 75.0581 53.8632 75.0581C51.7451 75.0581 50.0331 73.3396 50.0331 71.2135C50.0331 69.0873 51.7451 67.3688 53.8632 67.3688C55.9812 67.3688 57.6932 69.0873 57.6932 71.2135Z",
    fill: "url(#paint6_linear_668_20221)"
  })), _g20 || (_g20 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.09
  }, /*#__PURE__*/React.createElement("path", {
    d: "M59.5947 85.4307H49.3767C48.6729 85.4307 48.0977 84.8601 48.0977 84.1469C48.0977 83.4404 48.6729 82.863 49.3767 82.863H59.5947C60.2985 82.863 60.8737 83.4404 60.8737 84.1469C60.8737 84.8533 60.2985 85.4307 59.5947 85.4307Z",
    fill: "white"
  }))), _g21 || (_g21 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.23
  }, /*#__PURE__*/React.createElement("path", {
    d: "M59.5677 85.2065H49.3767C48.7947 85.2065 48.3211 84.731 48.3211 84.1468C48.3211 83.5626 48.7947 83.0872 49.3767 83.0872H59.5677C60.1496 83.0872 60.6233 83.5626 60.6233 84.1468C60.6233 84.731 60.1496 85.2065 59.5677 85.2065Z",
    fill: "#0D1214"
  }))), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M70.5436 72.4363C70.5436 72.8438 70.2188 73.1699 69.8128 73.1699C69.4068 73.1699 69.082 72.8438 69.082 72.4363C69.082 72.0287 69.4068 71.7026 69.8128 71.7026C70.2188 71.7026 70.5436 72.0287 70.5436 72.4363Z",
    fill: "url(#paint7_linear_668_20221)"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M38.8474 72.4363C38.8474 72.8438 38.5226 73.1699 38.1165 73.1699C37.7105 73.1699 37.3857 72.8438 37.3857 72.4363C37.3857 72.0287 37.7105 71.7026 38.1165 71.7026C38.5226 71.7026 38.8474 72.0287 38.8474 72.4363Z",
    fill: "url(#paint8_linear_668_20221)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_668_20221",
    x1: 27.1514,
    y1: 41.1256,
    x2: 41.4634,
    y2: 41.1256,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFDE3B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF8F3B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_668_20221",
    x1: 34.3068,
    y1: 45.0751,
    x2: 34.3068,
    y2: 37.1752,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFDE3B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF8F3B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_668_20221",
    x1: 65.9962,
    y1: -1.00003,
    x2: 80.315,
    y2: -1.00003,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFDE3B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF8F3B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_668_20221",
    x1: 73.1556,
    y1: 45.0751,
    x2: 73.1556,
    y2: 37.1752,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFDE3B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF8F3B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_668_20221",
    x1: 36.1812,
    y1: 72.4363,
    x2: 40.0587,
    y2: 72.4363,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFDE3B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF8F3B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_668_20221",
    x1: 67.8707,
    y1: 72.4362,
    x2: 71.7481,
    y2: 72.4362,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFDE3B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF8F3B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_668_20221",
    x1: 53.8632,
    y1: 75.0581,
    x2: 53.8632,
    y2: 67.3688,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFDE3B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF8F3B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_668_20221",
    x1: 69.8128,
    y1: 73.1699,
    x2: 69.8128,
    y2: 71.7026,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFDE3B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF8F3B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear_668_20221",
    x1: 38.1165,
    y1: 73.1699,
    x2: 38.1165,
    y2: 71.7026,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFDE3B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF8F3B"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_668_20221"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 110,
    height: 110,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTeslaSocket);
export default __webpack_public_path__ + "static/media/tesla_socket.f0a41614a9740b961fc8486c8de4b1c5.svg";
export { ForwardRef as ReactComponent };